// //  import { useEffect, useState } from "react";
// // import { useParams, useSearchParams, useNavigate } from "react-router-dom";
// // import Navbar from "../components/Navbar";
// // import ItemGrid from "../components/ItemGrid";

// // function ItemDetail() {
// //   const { id } = useParams();
// //   const [searchParams] = useSearchParams();
// //   const navigate = useNavigate();

// //   const [item, setItem] = useState(null);
// //   const [suggestions, setSuggestions] = useState([]);
// //   const [search, setSearch] = useState(searchParams.get("search") || "");

// //   // ✅ logged in user
// //   const user = JSON.parse(localStorage.getItem("user") || "null");
// //   const token = localStorage.getItem("token");

// //   /* ---------------- CHAT NOW ---------------- */
// //   const handleChat = async () => {
// //     const res = await fetch("https://borrowhub-backend.onrender.com/api/chat/start", {
// //       method: "POST",
// //       headers: {
// //         "Content-Type": "application/json",
// //         Authorization: `Bearer ${token}`,
// //       },
// //       body: JSON.stringify({
// //         itemId: item._id,
// //         otherUserId: item.owner._id,
// //       }),
// //     });

// //     const conversation = await res.json();
// //     navigate(`/chat/${conversation._id}`);
// //   };

// //   /* ---------------- DELETE ITEM ---------------- */
// //   const handleDeleteItem = async () => {
// //     if (!window.confirm("Are you sure you want to remove this item?")) return;

// //     try {
// //       const res = await fetch(` https://borrowhub-backend.onrender.com/api/items/${id}`, {
// //         method: "DELETE",
// //         headers: {
// //           Authorization: `Bearer ${token}`,
// //         },
// //       });

// //       if (!res.ok) {
// //         alert("Failed to delete item");
// //         return;
// //       }

// //       alert("Item removed successfully 🗑️");
// //       navigate("/my-items");
// //     } catch (err) {
// //       alert("Something went wrong");
// //     }
// //   };

// //   /* ---------------- FETCH ITEM ---------------- */
// //   useEffect(() => {
// //     const fetchItem = async () => {
// //       try {
// //         const res = await fetch(` https://borrowhub-backend.onrender.com/api/items/${id}`);
// //         const data = await res.json();

// //         if (data.item) {
// //           setItem(data.item);
// //           setSuggestions(data.suggestions || []);
// //         }
// //       } catch (err) {
// //         console.error("fetchItem error:", err);
// //       }
// //     };

// //     fetchItem();
// //   }, [id]);

// //   /* ---------------- LOADING ---------------- */
// //   if (!item) {
// //     return (
// //       <>
// //         <Navbar search={search} setSearch={setSearch} />
// //         <div className="text-center mt-5">
// //           <h5>Loading item…</h5>
// //         </div>
// //       </>
// //     );
// //   }

// //   // ✅ Check if current user is the owner
// //   // (Moved this AFTER loading check to prevent crash)
// //   const isOwner = user && item.owner && (user._id === item.owner._id || user.userId === item.owner._id);

// //   /* ---------------- UI ---------------- */
// //   return (
// //     <>
// //       <Navbar search={search} setSearch={setSearch} />

// //       <div className="container mt-4">
// //         <div className="row">
// //           {/* ================= LEFT ================= */}
// //           <div className="col-md-8">
// //             {/* BASIC INFO */}
// //             <div className="card mb-3">
// //               <div className="card-body">
// //                 <h3 className="fw-bold">{item.title}</h3>

// //                 <div className="d-flex gap-2 mb-2 flex-wrap">
// //                   <span className="badge bg-success">{item.category}</span>

// //                   {item.location?.city && (
// //                     <span className="badge bg-light text-dark">
// //                       📍 {item.location.city}
// //                       {item.location.address && `, ${item.location.address}`}
// //                     </span>
// //                   )}
// //                 </div>

// //                 {item.condition && (
// //                   <span className="badge bg-light text-success">
// //                     Condition: {item.condition}
// //                   </span>
// //                 )}
// //               </div>
// //             </div>

// //             {/* IMAGES + DESCRIPTION */}
// //             <div className="card">
// //               <div className="card-body">
// //                 {/* IMAGE SLIDER */}
// //                 {item.images?.length > 0 && (
// //                   <div
// //                     id="itemImageCarousel"
// //                     className="carousel slide mb-3"
// //                     data-bs-ride="carousel"
// //                   >
// //                     {item.images.length > 1 && (
// //                       <div className="carousel-indicators">
// //                         {item.images.map((_, index) => (
// //                           <button
// //                             key={index}
// //                             type="button"
// //                             data-bs-target="#itemImageCarousel"
// //                             data-bs-slide-to={index}
// //                             className={index === 0 ? "active" : ""}
// //                           />
// //                         ))}
// //                       </div>
// //                     )}

// //                     <div className="carousel-inner border rounded">
// //                       {item.images.map((img, index) => (
// //                         <div
// //                           key={index}
// //                           className={`carousel-item ${
// //                             index === 0 ? "active" : ""
// //                           }`}
// //                         >
// //                           <img
// //                             src={img.url}
// //                             className="d-block w-100"
// //                             style={{
// //                               height: "300px",
// //                               objectFit: "contain",
// //                               background: "#fff",
// //                             }}
// //                             alt=""
// //                           />
// //                         </div>
// //                       ))}
// //                     </div>

// //                     {item.images.length > 1 && (
// //                       <>
// //                         <button
// //                           className="carousel-control-prev"
// //                           type="button"
// //                           data-bs-target="#itemImageCarousel"
// //                           data-bs-slide="prev"
// //                         >
// //                           <span className="carousel-control-prev-icon" />
// //                         </button>

// //                         <button
// //                           className="carousel-control-next"
// //                           type="button"
// //                           data-bs-target="#itemImageCarousel"
// //                           data-bs-slide="next"
// //                         >
// //                           <span className="carousel-control-next-icon" />
// //                         </button>
// //                       </>
// //                     )}
// //                   </div>
// //                 )}

// //                 {item.description && (
// //                   <>
// //                     <h5>Description</h5>
// //                     <p className="text-muted">{item.description}</p>
// //                   </>
// //                 )}
// //               </div>
// //             </div>
// //           </div>

// //           {/* ================= RIGHT ================= */}
// //           <div className="col-md-4">
// //             <div className="card sticky-top" style={{ top: "80px" }}>
// //               <div className="card-body">
// //                 <h4 className="text-success">
// //                   ₹{item.pricePerDay || "Not set"} <small>/ day</small>
// //                 </h4>

// //                 <p className="text-muted">
// //                   Security Deposit: ₹{item.deposit || "Not set"}
// //                 </p>

// //                 <hr />

// //                 {item.owner && (
// //                   <>
// //                     <h6>Owner</h6>
// //                     <p className="mb-1">👤 {item.owner.name}</p>
// //                     <p className="text-muted">⭐ {item.owner.rating}</p>
// //                   </>
// //                 )}

// //                 {/* 🔥🔥 BUTTON LOGIC UPDATED 🔥🔥 */}
// //                 {isOwner ? (
// //                   // CASE 1: LOGGED IN USER IS THE OWNER
// //                   <>
// //                     <button
// //                       className="btn btn-secondary w-100 mt-2"
// //                       disabled
// //                     >
// //                       🚫 You Own This Item
// //                     </button>

                     
// //                   </>
// //                 ) : (
// //                   // CASE 2: USER IS A BORROWER (NOT OWNER)
// //                   <>
// //                     {item.status === "available" ? (
// //                       <button
// //                         className="btn btn-success w-100 mt-2"
// //                         onClick={() => navigate(`/borrow/${item._id}`)}
// //                       >
// //                         Borrow Now
// //                       </button>
// //                     ) : (
// //                       <button
// //                         className="btn btn-secondary w-100 mt-2"
// //                         disabled
// //                       >
// //                         Unavailable
// //                       </button>
// //                     )}

// //                     <button
// //                       className="btn btn-success w-100 mt-2"
// //                       onClick={handleChat}
// //                     >
// //                       Chat Now
// //                     </button>
// //                   </>
// //                 )}

// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //         {/* ================= SUGGESTIONS ================= */}
// //         {suggestions.length > 0 && (
// //           <div className="mt-5">
// //             <h5 className="fw-bold">Similar items you may like</h5>
// //             <ItemGrid items={suggestions} />
// //           </div>
// //         )}
// //       </div>
// //     </>
// //   );
// // }

// // export default ItemDetail;






// import { useEffect, useState } from "react";
// import { useParams, useSearchParams, useNavigate } from "react-router-dom";
// import Navbar from "../components/Navbar";
// import ItemGrid from "../components/ItemGrid";

// function ItemDetail() {
//   const { id } = useParams();
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();

//   const [item, setItem] = useState(null);
//   const [suggestions, setSuggestions] = useState([]);
//   const [search, setSearch] = useState(searchParams.get("search") || "");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null); // 🔥 Error State Added

//   // ✅ logged in user
//   const user = JSON.parse(localStorage.getItem("user") || "null");
//   const token = localStorage.getItem("token");

//   /* ---------------- CHAT NOW ---------------- */
//   const handleChat = async () => {
//     if (!token) return alert("Please login to chat");
    
//     try {
//       const res = await fetch("https://borrowhub-backend.onrender.com/api/chat/start", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({
//           itemId: item._id,
//           otherUserId: item.owner._id,
//         }),
//       });

//       const conversation = await res.json();
//       if (conversation._id) {
//           navigate(`/chat/${conversation._id}`);
//       } else {
//           alert("Could not start chat");
//       }
//     } catch (err) {
//       alert("Error starting chat");
//     }
//   };

//   /* ---------------- DELETE ITEM ---------------- */
//   const handleDeleteItem = async () => {
//     if (!window.confirm("Are you sure you want to remove this item?")) return;

//     try {
//       const res = await fetch(` https://borrowhub-backend.onrender.com/api/items/${id}`, {
//         method: "DELETE",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!res.ok) {
//         alert("Failed to delete item");
//         return;
//       }

//       alert("Item removed successfully 🗑️");
//       navigate("/my-items");
//     } catch (err) {
//       alert("Something went wrong");
//     }
//   };

//   /* ---------------- FETCH ITEM (SAFE VERSION) ---------------- */
//   useEffect(() => {
//     const fetchItem = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         console.log("Fetching Item ID:", id); // Debugging Log
//         const res = await fetch(` https://borrowhub-backend.onrender.com/api/items/${id}`);
        
//         if (!res.ok) {
//             throw new Error(`Server Error: ${res.status}`);
//         }

//         const data = await res.json();

//         // 🔥 CRITICAL CHECK
//         if (data.success && data.item) {
//           setItem(data.item);
//           setSuggestions(data.suggestions || []);
//         } else {
//           setError("Item not found in database.");
//         }
//       } catch (err) {
//         console.error("fetchItem error:", err);
//         setError("API Connection Failed. Check Backend Console.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (id) fetchItem();
//   }, [id]);

//   /* ---------------- LOADING & ERROR STATES ---------------- */
//   if (loading) {
//     return (
//       <>
//         <Navbar search={search} setSearch={setSearch} />
//         <div className="text-center mt-5">
//           <div className="spinner-border text-success" role="status"></div>
//           <p className="mt-2 text-muted">Loading item details...</p>
//         </div>
//       </>
//     );
//   }

//   if (error) {
//     return (
//       <>
//         <Navbar search={search} setSearch={setSearch} />
//         <div className="container mt-5 text-center">
//             <h3 className="text-danger fw-bold">⚠️ Oops! Error</h3>
//             <p className="lead">{error}</p>
//             <button className="btn btn-dark" onClick={() => navigate("/")}>Go Home</button>
//         </div>
//       </>
//     );
//   }

//   if (!item) return null; // Safety

//   // ✅ Check if current user is the owner
//   const isOwner = user && item.owner && (user._id === item.owner._id || user.userId === item.owner._id);

//   /* ---------------- UI ---------------- */
//   return (
//     <>
//       <Navbar search={search} setSearch={setSearch} />

//       <div className="container mt-4">
//         <div className="row">
//           {/* ================= LEFT ================= */}
//           <div className="col-md-8">
//             {/* BASIC INFO */}
//             <div className="card mb-3 shadow-sm border-0">
//               <div className="card-body">
//                 {/* 🔥 Safe Access with Optional Chaining (?.) */}
//                 <h3 className="fw-bold">{item?.title}</h3>

//                 <div className="d-flex gap-2 mb-2 flex-wrap">
//                   <span className="badge bg-success">{item?.category}</span>

//                   {item?.location?.city && (
//                     <span className="badge bg-light text-dark border">
//                       📍 {item.location.city}
//                       {item.location.address && `, ${item.location.address}`}
//                     </span>
//                   )}
//                 </div>

//                 {item?.condition && (
//                   <span className="badge bg-light text-success border">
//                     Condition: {item.condition}
//                   </span>
//                 )}
//               </div>
//             </div>

//             {/* IMAGES + DESCRIPTION */}
//             <div className="card shadow-sm border-0">
//               <div className="card-body">
//                 {/* IMAGE SLIDER */}
//                 {item?.images?.length > 0 ? (
//                   <div id="itemImageCarousel" className="carousel slide mb-3" data-bs-ride="carousel">
//                     {item.images.length > 1 && (
//                       <div className="carousel-indicators">
//                         {item.images.map((_, index) => (
//                           <button key={index} type="button" data-bs-target="#itemImageCarousel" data-bs-slide-to={index} className={index === 0 ? "active" : ""} />
//                         ))}
//                       </div>
//                     )}

//                     <div className="carousel-inner border rounded bg-light">
//                       {item.images.map((img, index) => (
//                         <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
//                           <img src={img.url} className="d-block w-100" style={{ height: "400px", objectFit: "contain" }} alt="Item" />
//                         </div>
//                       ))}
//                     </div>

//                     {item.images.length > 1 && (
//                       <>
//                         <button className="carousel-control-prev" type="button" data-bs-target="#itemImageCarousel" data-bs-slide="prev">
//                           <span className="carousel-control-prev-icon bg-dark rounded-circle p-2" />
//                         </button>
//                         <button className="carousel-control-next" type="button" data-bs-target="#itemImageCarousel" data-bs-slide="next">
//                           <span className="carousel-control-next-icon bg-dark rounded-circle p-2" />
//                         </button>
//                       </>
//                     )}
//                   </div>
//                 ) : (
//                     <div className="text-center p-5 bg-light rounded text-muted">No Images Available</div>
//                 )}

//                 {item?.description && (
//                   <>
//                     <h5 className="fw-bold mt-4">Description</h5>
//                     <p className="text-muted" style={{whiteSpace: "pre-line"}}>{item.description}</p>
//                   </>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* ================= RIGHT ================= */}
//           <div className="col-md-4">
//             <div className="card sticky-top shadow-sm border-0" style={{ top: "90px" }}>
//               <div className="card-body">
//                 <h4 className="text-success fw-bold">
//                   ₹{item?.pricePerDay || "0"} <small className="text-muted fs-6">/ day</small>
//                 </h4>

//                 <p className="text-muted small">
//                   Security Deposit: ₹{item?.deposit || "0"}
//                 </p>

//                 <hr />

//                 {item?.owner && (
//                   <div className="d-flex align-items-center mb-3">
//                      <div className="bg-light rounded-circle d-flex align-items-center justify-content-center fw-bold text-secondary me-2" style={{width: 40, height: 40}}>
//                         {item.owner.name?.charAt(0).toUpperCase()}
//                      </div>
//                      <div>
//                         <p className="mb-0 fw-bold">{item.owner.name}</p>
//                         <small className="text-muted">Owner</small>
//                      </div>
//                   </div>
//                 )}

//                 {/* BUTTONS */}
//                 {isOwner ? (
//                     <>
//                         <button className="btn btn-secondary w-100 mt-2" disabled>
//                             🚫 You Own This Item
//                         </button>
//                         <button className="btn btn-outline-danger w-100 mt-2" onClick={handleDeleteItem}>
//                             🗑️ Remove Item
//                         </button>
//                     </>
//                 ) : (
//                   <>
//                     {item?.status === "available" ? (
//                       <button className="btn btn-success w-100 mt-2 fw-bold" onClick={() => navigate(`/borrow/${item._id}`)}>
//                         ⚡ Borrow Now
//                       </button>
//                     ) : (
//                       <button className="btn btn-secondary w-100 mt-2" disabled>
//                         ❌ Unavailable ({item.status})
//                       </button>
//                     )}

//                     <button className="btn btn-outline-success w-100 mt-2" onClick={handleChat}>
//                       💬 Chat with Owner
//                     </button>
//                   </>
//                 )}

//               </div>
//             </div>
//           </div>
//         </div>

//         {/* ================= SUGGESTIONS ================= */}
//         {suggestions.length > 0 && (
//           <div className="mt-5 mb-5">
//             <h4 className="fw-bold mb-3">Similar items you may like</h4>
//             <ItemGrid items={suggestions} />
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// export default ItemDetail;





import { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import ItemGrid from "../components/ItemGrid";

function ItemDetail() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [item, setItem] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [search, setSearch] = useState(searchParams.get("search") || "");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ✅ logged in user
  const user = JSON.parse(localStorage.getItem("user") || "null");
  const token = localStorage.getItem("token");

  /* ---------------- CHAT NOW ---------------- */
  const handleChat = async () => {
    if (!token) return alert("Please login to chat");
    
    try {
      const res = await fetch("https://borrowhub-backend.onrender.com/api/chat/start", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          itemId: item._id,
          otherUserId: item.owner._id,
        }),
      });

      const conversation = await res.json();
      if (conversation._id) {
          navigate(`/chat/${conversation._id}`);
      } else {
          alert("Could not start chat");
      }
    } catch (err) {
      alert("Error starting chat");
    }
  };

  /* ---------------- DELETE ITEM ---------------- */
  const handleDeleteItem = async () => {
    if (!window.confirm("Are you sure you want to remove this item?")) return;

    try {
      const res = await fetch(` https://borrowhub-backend.onrender.com/api/items/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        alert("Failed to delete item");
        return;
      }

      alert("Item removed successfully 🗑️");
      navigate("/my-items");
    } catch (err) {
      alert("Something went wrong");
    }
  };

  /* ---------------- FETCH ITEM (SAFE VERSION) ---------------- */
  useEffect(() => {
    const fetchItem = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(` https://borrowhub-backend.onrender.com/api/items/${id}`);
        
        if (!res.ok) {
            throw new Error(`Server Error: ${res.status}`);
        }

        const data = await res.json();

        // 🔥 CRITICAL CHECK
        if (data.success && data.item) {
          setItem(data.item);
          setSuggestions(data.suggestions || []);
        } else {
          setError("Item not found in database.");
        }
      } catch (err) {
        console.error("fetchItem error:", err);
        setError("API Connection Failed. Check Backend Console.");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchItem();
  }, [id]);

  /* ---------------- LOADING & ERROR STATES ---------------- */
  if (loading) {
    return (
      <>
        <Navbar search={search} setSearch={setSearch} />
        <div className="text-center mt-5">
          <div className="spinner-border text-success" role="status"></div>
          <p className="mt-2 text-muted">Loading item details...</p>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Navbar search={search} setSearch={setSearch} />
        <div className="container mt-5 text-center">
            <h3 className="text-danger fw-bold">⚠️ Oops! Error</h3>
            <p className="lead">{error}</p>
            <button className="btn btn-dark" onClick={() => navigate("/")}>Go Home</button>
        </div>
      </>
    );
  }

  if (!item) return null; // Safety

  // ✅ Check if current user is the owner
  const isOwner = user && item.owner && (user._id === item.owner._id || user.userId === item.owner._id);

  /* ---------------- UI ---------------- */
  return (
    <>
      <Navbar search={search} setSearch={setSearch} />

      <div className="container mt-4">
        <div className="row">
          {/* ================= LEFT ================= */}
          <div className="col-md-8">
            {/* BASIC INFO */}
            <div className="card mb-3 shadow-sm border-0">
              <div className="card-body">
                {/* 🔥 Safe Access with Optional Chaining (?.) */}
                <h3 className="fw-bold">{item?.title}</h3>

                <div className="d-flex gap-2 mb-2 flex-wrap">
                  <span className="badge bg-success">{item?.category}</span>

                  {/* 🔥 FIX: Address Logic (Root ya Location dono check karega) */}
                  {(item.city || item.location?.city) && (
                    <span className="badge bg-light text-success border border-success">
                      📍 {item.city || item.location?.city}
                      {(item.address || item.location?.address) && `, ${item.address || item.location?.address}`}
                    </span>
                  )}
                </div>

                {item?.condition && (
                  <span className="badge bg-light text-success border">
                    Condition: {item.condition}
                  </span>
                )}
              </div>
            </div>

            {/* IMAGES + DESCRIPTION */}
            <div className="card shadow-sm border-0">
              <div className="card-body">
                {/* IMAGE SLIDER */}
                {item?.images?.length > 0 ? (
                  <div id="itemImageCarousel" className="carousel slide mb-3" data-bs-ride="carousel">
                    {item.images.length > 1 && (
                      <div className="carousel-indicators">
                        {item.images.map((_, index) => (
                          <button key={index} type="button" data-bs-target="#itemImageCarousel" data-bs-slide-to={index} className={index === 0 ? "active" : ""} />
                        ))}
                      </div>
                    )}

                    <div className="carousel-inner border rounded bg-light">
                      {item.images.map((img, index) => (
                        <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                          <img src={img.url} className="d-block w-100" style={{ height: "400px", objectFit: "contain" }} alt="Item" />
                        </div>
                      ))}
                    </div>

                    {item.images.length > 1 && (
                      <>
                        <button className="carousel-control-prev" type="button" data-bs-target="#itemImageCarousel" data-bs-slide="prev">
                          <span className="carousel-control-prev-icon bg-dark rounded-circle p-2" />
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#itemImageCarousel" data-bs-slide="next">
                          <span className="carousel-control-next-icon bg-dark rounded-circle p-2" />
                        </button>
                      </>
                    )}
                  </div>
                ) : (
                    <div className="text-center p-5 bg-light rounded text-muted">No Images Available</div>
                )}

                {item?.description && (
                  <>
                    <h5 className="fw-bold mt-4">Description</h5>
                    <p className="text-muted" style={{whiteSpace: "pre-line"}}>{item.description}</p>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* ================= RIGHT ================= */}
          <div className="col-md-4">
            <div className="card sticky-top shadow-sm border-0" style={{ top: "90px" }}>
              <div className="card-body">
                <h4 className="text-success fw-bold">
                  ₹{item?.pricePerDay || "0"} <small className="text-muted fs-6">/ day</small>
                </h4>

                <p className="text-muted small">
                  Security Deposit: ₹{item?.deposit || "0"}
                </p>

                <hr />

                {item?.owner && (
                  <div className="d-flex align-items-center mb-3">
                     <div className="bg-light rounded-circle d-flex align-items-center justify-content-center fw-bold text-secondary me-2" style={{width: 40, height: 40}}>
                        {item.owner.name?.charAt(0).toUpperCase()}
                     </div>
                     <div>
                        <p className="mb-0 fw-bold">{item.owner.name}</p>
                        <small className="text-muted">Owner</small>
                     </div>
                  </div>
                )}

                {/* BUTTONS */}
                {isOwner ? (
                    <>
                        <button className="btn btn-secondary w-100 mt-2" disabled>
                            🚫 You Own This Item
                        </button>
                        <button className="btn btn-outline-danger w-100 mt-2" onClick={handleDeleteItem}>
                            🗑️ Remove Item
                        </button>
                    </>
                ) : (
                  <>
                    {item?.status === "available" ? (
                      <button className="btn btn-success w-100 mt-2 fw-bold" onClick={() => navigate(`/borrow/${item._id}`)}>
                        ⚡ Borrow Now
                      </button>
                    ) : (
                      <button className="btn btn-secondary w-100 mt-2" disabled>
                        ❌ Unavailable ({item.status})
                      </button>
                    )}

                    <button className="btn btn-outline-success w-100 mt-2" onClick={handleChat}>
                      💬 Chat with Owner
                    </button>
                  </>
                )}

              </div>
            </div>
          </div>
        </div>

        {/* ================= SUGGESTIONS ================= */}
        {suggestions.length > 0 && (
          <div className="mt-5 mb-5">
            <h4 className="fw-bold mb-3">Similar items you may like</h4>
            <ItemGrid items={suggestions} />
          </div>
        )}
      </div>
    </>
  );
}

export default ItemDetail;